import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useSystemOptionsStore } from '../stores/useOptions';
import ContactFormModal from './ContactForm';

const FloatingContactButton = () => {
    const [showModal, setShowModal] = useState(false);
    const { systemOptions } = useSystemOptionsStore();

    if (!systemOptions.mailAyuda) return null;

    return (
        <>
            <Button
                style={{
                    position: 'fixed',
                    bottom: '30px', // Más cerca del bottom
                    right: '20px',
                    borderRadius: '50%',
                    width: '60px', // Un poco más grande
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)', // Sombra suave
                    background: '#0d6efd', // Color primario de Bootstrap
                    border: 'none',
                }}
                variant="primary"
                onClick={() => setShowModal(true)}
                title="¿Necesitas ayuda?"
            >
                <i 
                    className="bi bi-question-circle-fill" 
                    style={{ 
                        fontSize: '32px', // Ícono más grande
                    }}
                />
            </Button>

            <ContactFormModal
                show={showModal}
                onHide={() => setShowModal(false)}
                mailDestino={systemOptions.mailAyuda}
            />
        </>
    );
};

export default FloatingContactButton;